import DashboardSectionBox from './DashboardSectionBox'

export default DashboardSectionBox
